import { z } from 'zod';
import { zStringRequired } from '../../z';
import { registry } from '../registry';
export const conditionOptions = [
    { value: 'stable', label: 'Stable' },
    { value: 'improved', label: 'Improved' },
    { value: 'unchanged', label: 'Unchanged' },
    { value: 'unstable', label: 'Unstable' },
    { value: 'declined', label: 'Declined' },
];
export const goalsStatusOptions = [
    { value: 'met', label: 'Met' },
    { value: 'not met', label: 'Not Met' },
    { value: 'partially met', label: 'Partially Met' },
];
export const dischargeServicesProvidedOptions = [
    { value: 'SN', label: 'Skilled Nursing' },
    { value: 'PT', label: 'Physical Therapy' },
    { value: 'OT', label: 'Occupational Therapy' },
    { value: 'ST', label: 'Speech Therapy' },
    { value: 'MSW', label: 'Medical Social Worker' },
    { value: 'HHA', label: 'Home Health Aide' },
    { value: 'Other', label: 'Other' },
];
export const dischargeDispositionOptions = [
    {
        value: 'Patient remained in the community (without formal assistive services)',
        label: '1. Patient remained in the community (without formal assistive services)',
    },
    {
        value: 'Patient remained in the community (with formal assistive services)',
        label: '2. Patient remained in the community (with formal assistive services)',
    },
    { value: '3. Patient transferred to a non-institutional hospice', label: '3. Patient transferred to a non-institutional hospice' },
    {
        value: '4. Unknown because patient moved to a geographic location not served by this agency',
        label: '4. Unknown because patient moved to a geographic location not served by this agency',
    },
    { value: 'UK. Other unknown', label: 'UK. Other unknown' },
];
export const yesNoOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
];
export const otherNotesOptions = [
    { value: 'All services notified and discontinued', label: 'All services notified and discontinued' },
    { value: 'Order and summary completed', label: 'Order and summary completed' },
    { value: 'Information provided to patient for continuing needs', label: 'Information provided to patient for continuing needs' },
    { value: 'Physician Notified', label: 'Physician Notified' },
];
export const baseDischargeSummary = z.object({
    condition: z.array(z.string()).min(1, 'Please select at least one').register(registry, {
        label: 'Patient Condition',
        options: conditionOptions,
    }),
    goalsStatus: zStringRequired().register(registry, { label: 'Goals', options: goalsStatusOptions }),
    servicesProvided: z.array(z.string()).min(1, 'Please select at least one').register(registry, {
        label: 'Services Provided',
        options: dischargeServicesProvidedOptions,
    }),
    careSummary: zStringRequired().register(registry, {
        label: 'Care Summary: (Care Given, Progress, Regress Including Therapies)',
    }),
    conditionOfDischarge: zStringRequired().register(registry, {
        label: 'Condition of Discharge (Include VS, BS, Functional and Overall Status)',
    }),
    dischargeDisposition: z.array(z.string()).min(1, 'Please select at least one').register(registry, {
        label: 'Discharge Disposition',
        options: dischargeDispositionOptions,
    }),
    dischargeInstructions: zStringRequired().register(registry, { label: 'Discharge Instructions' }),
    verbalizedUnderstanding: zStringRequired().register(registry, { label: 'Verbalized Understanding', options: yesNoOptions }),
    otherNotes: z.array(z.string()).optional().register(registry, { label: 'Other', options: otherNotesOptions }),
});
export const dischargeSummaryValidationSchema = z.object({
    id: z.string(),
    data: baseDischargeSummary,
});
